// extracted by mini-css-extract-plugin
export default {"formContainer":"device-detail-form_formContainer__u5SmX","padding":"device-detail-form_padding__lcFyP"};